export const hasMinLength = (password: string) => password.length >= 6;

export const hasNumber = (password: string) => /\d/.test(password);

export const hasLetter = (password: string) => /[a-zA-Z]/.test(password);
